import { Range } from 'react-date-range';

import { Text } from 'components';
import { formatDateToBR } from 'helpers';

interface ReportLoaderProps {
  dateRange: Range;
}

export function ReportLoader(props: ReportLoaderProps) {
  const { dateRange } = props;
  const { startDate, endDate } = dateRange;

  function renderLoader() {
    return (
      <div
        className="w-12 h-12 border-4 border-transparent border-t-gray-300 rounded-full
          animate-spin border-solid"
      ></div>
    );
  }

  function renderDotsLoader() {
    return (
      <span className="inline-block">
        <span className="mr-1 text-lg font-bold text-neutral-500 animate-[blink_1.4s_infinite]">
          .
        </span>
        <span className="mr-1 text-lg font-bold text-neutral-500 animate-[blink_1.4s_infinite_0.2s]">
          .
        </span>
        <span className="mr-1 text-lg font-bold text-neutral-500 animate-[blink_1.4s_infinite_0.4s]">
          .
        </span>
      </span>
    );
  }

  return (
    <div>
      <div className="flex w-full gap-4 p-4 rounded-lg bg-neutral-200">
        {renderLoader()}
        <div className="flex flex-col gap-1.5 flex-grow">
          <div className="flex items-center gap-1">
            <span className="text-sm font-bold text-neutral-500">
              Gerando relatório
            </span>
            {renderDotsLoader()}
          </div>
          <span className="text-xs text-neutral-500">
            Consulta de{' '}
            <span className="font-bold">
              {formatDateToBR(startDate)} a {formatDateToBR(endDate)}
            </span>
          </span>
        </div>
      </div>
      <Text className="mt-4">
        Seu relatório está sendo gerado e pode levar alguns minutos, fique à
        vontade para usar o painel normalmente.
        <br />
        <span className="font-bold">
          Te avisaremos quando o relatório estiver pronto.
        </span>
      </Text>
    </div>
  );
}
